module.exports = __webpack_public_path__ + "img/ZTOBUHaveOrder_02.5615d710.jpg";